console.log(1);
var SELECTOR_CART_CONTAINER = '[data-lines-container]';
var SELECTOR_CART_FOOTER = '[data-cart-footer]';
var cartConatiner = document.querySelector(SELECTOR_CART_CONTAINER);
var cartFooter = document.querySelector(SELECTOR_CART_FOOTER);
cartFooter === null || cartFooter === void 0 ? void 0 : cartFooter.addEventListener('scroll', function (e) {
  if (!cartConatiner) return;
  cartConatiner.scrollTo(0, 0);
});